import { Path } from 'config/portal'
import { AgreementsMapping } from 'config/products'
import { RecordTypes } from 'flatfile-config'
import { PlanConfirmationForm } from '../forms'
import { selectors } from '../reducer'
import * as actions from '../actions'
import * as apiActions from 'api-actions'
import createPlanConfirmationView from '../../products/views/createPlanConfirmationView'

export default createPlanConfirmationView({
  PlanConfirmationFormComponent: PlanConfirmationForm,
  agreementsMapping: AgreementsMapping.TAXABLE_ACCOUNTS_PLAN_MATCHING,
  nextPath: '/taxable-accounts/review-and-submit-participant-data',
  uploadFilePath: '/taxable-accounts/upload-file',
  allParticipantsRemovedPath: Path.TAXABLE_ACCOUNTS_SERVICES_AGREEMENTS,
  recordType: RecordTypes.TAXABLE_ACCOUNTS_PARTICIPANT,
  selectors,
  actions,
  fetchAgreementsAction: apiActions.fetchCompletedServicesAgreements,
  agreementsSelectorFn: (state) => selectors.completedServicesAgreements(state),
})
